import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isNullOrUndefined } from "../../common/utils";
import { KeyConditionActions } from "../../pages/userGroups/KeyCondition/model";
import { createConditionTree } from "../condition/utils/createConditionTree";
import { getInputValuesFromGivenCondition } from "../condition/utils/getInputValuesFromGivenCondition";
import { isNullCondition } from "../condition/utils/isNullCondition";
import "./index.scss";
import { keyConditionTransitionsBasedOnInputs } from "./keyConditionTransitionsBasedOnInputs";

function SelectedUserInput({ attribute, value, isIndividualInclusionMember }) {
  const [selectedState, setSelectedState] = useState(false);
  const dispatch = useDispatch();
  const isSpecialConditionChecked = useSelector(
    (rootState) => rootState.keyCondition.isSpecialConditionChecked,
  );

  const editedMembershipCondition = useSelector((rootState) => {
    return rootState.keyCondition.modifiedKeyCondition;
  });
  const [keyCondition, setkeyCondition] = useState(null);

  useEffect(() => {
    const editedConditionTree = createConditionTree(editedMembershipCondition);
    setkeyCondition(editedConditionTree);
    const selectedValue = getInputValuesFromGivenCondition(editedConditionTree);
    if (!isNullOrUndefined(selectedValue[attribute.attributeName])) {
      setSelectedState(true);
    }
  }, [editedMembershipCondition]);

  useEffect(() => {
    let keyConditionCopy = keyCondition;
    if (!isNullCondition(keyConditionCopy)) {
      keyConditionCopy = keyConditionCopy.toJSON(true);
    }
    dispatch(KeyConditionActions.setModifiedKeyCondition(keyConditionCopy));
  }, [selectedState]);

  function toggleSelection() {
    let changedValue;
    if (selectedState === true) {
      setSelectedState(false);
    } else {
      setSelectedState(true);
      changedValue = {
        [attribute.attributeName]: [value],
      };
    }

    let keyConditionCopy = keyCondition;
    keyConditionCopy = keyConditionTransitionsBasedOnInputs(
      keyConditionCopy,
      attribute.attributeName,
      changedValue?.[attribute.attributeName],
    );
    setkeyCondition(keyConditionCopy);
  }

  function setStyleForSelectedAttribute() {
    if (isSpecialConditionChecked === false) {
      return selectedState === true ? "selected-attribute" : "";
    } else {
      return "disable-cursor-user-attributes";
    }
  }

  function disableUserAttributes() {
    return isSpecialConditionChecked === true ? "disable-user-attributes" : "";
  }

  function getTooltipTitle() {
    return isIndividualInclusionMember === true
      ? ""
      : isSpecialConditionChecked === true
        ? "Uncheck special condition to enable editing key condition"
        : "";
  }

  return (
    <div className="keycondition-individual-input">
      <div className="keycondition-individual-input-label">{attribute.label}</div>
      <Tooltip
        placement="top"
        title={getTooltipTitle()}
      >
        <div className={setStyleForSelectedAttribute()}>
          <div
            className={`selected-user-attribute-box selected-user-attribute-text ${disableUserAttributes()}`}
            onClick={toggleSelection}
          >
            <div style={{ paddingLeft: "8px", paddingRight: "12px" }}>{value}</div>
            <div style={{ paddingRight: "8px" }}>
              {selectedState === true ? <CloseOutlined/> : <CheckOutlined/>}
            </div>
          </div>
        </div>
      </Tooltip>
    </div>
  );
}

export default SelectedUserInput;
